<div id="login-container" fxLayout="column" fxLayoutAlign="center center">
  <mat-card
    class="example-container"
    fxFlex="30%"
    fxFlex.lt-md="65%"
    fxFlex.lt-sm="95%"
  >
    <mat-card-title>
      {{ titleText }}
    </mat-card-title>
    <form [formGroup]="loginForm" (ngSubmit)="submitFun()">
      <mat-card-content>
        <mat-error *ngIf="error.error">{{ error.msg }} </mat-error>
        <P class="success" *ngIf="error.success">{{ error.msg }}</P>
        <mat-form-field appearance="fill" fxFlex="100%">
          <label>{{ emailText }}</label>
          <input matInput formControlName="email" />
          <mat-error *ngIf="errorHandling('email', 'required')">
            {{ emailError }}
          </mat-error>
        </mat-form-field>
        <br /><br />
        <mat-form-field appearance="fill" fxFlex="100%">
          <label>{{ passwordText }}</label>
          <input
            matInput
            [type]="hide3 ? 'password' : 'text'"
            formControlName="password"
          />
          <mat-icon
            fontSet="material-icons-outlined"
            matSuffix
            (click)="hide3 = !hide3"
          >
            {{ hide3 ? "visibility_off" : "visibility" }}</mat-icon
          >
          <mat-error
            *ngIf="
              errorHandling('password', 'required') ||
              errorHandling('password', 'password')
            "
          >
            {{ passwordError }}
          </mat-error>
        </mat-form-field>
        <button
          class="forgotpass right link"
          mat-flat-button
          routerLink="/forgot"
          type="button"
        >
          {{ forgotPasswordLink }}
        </button>
      </mat-card-content>
      <mat-card-actions class="right center-align">
        <button
          *ngIf="!loadSpinner"
          mat-flat-button
          class="btn"
        
        >
          {{ buttonText }}
        </button>
        <button
          *ngIf="loadSpinner"
          mat-flat-button
          class="btn"
         
        >
          Logging In..
          <span>
            <mat-progress-spinner
              style="float: right; margin-top: 2px; margin-left: 8px"
              color="primary"
              mode="indeterminate"
              [diameter]="18"
              title="Loading....."
            >
            </mat-progress-spinner>
          </span>
        </button>
      </mat-card-actions>
    </form>
  </mat-card>
</div>
